import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinActionRoute: InvariantJiraRoute = {
	name: 'legacy-gin-action',
	path: '/secure/IssueNavAction!default.jspa',
	query: ['filter|jql|issueKey'],
};
